import { Trip } from './../classes.js';
import { update_marker_display } from './../runtime/registerMap.js';
import { can_display } from './../function/common.js';

export class cEventManager {
	constructor() {

		this.data = {
			'map': 1
			, 'date_time': 1
			, 'description': 1
			, 'expenses': 0
			, 'location_link': 0
			, 'directions_link': 0
		};
		
		this.style = {}
		
		$('body').on('click', '.event_manager--open', {obj: this}, function(e){
			e.preventDefault();
			let ev = {
				'block_id': $(this).closest('.e').attr('data-block_id')
				, 'el_id': $(this).closest('.e').attr('data-el_id')
			}
			
			e.data.obj.set_event(ev);
			e.data.obj.open();
		})
		
		$('body').on('click', '.event_manager--close', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.close();
		})
		
		$('body').on('click', '.ev_list li', {obj: this}, function(e){
			e.preventDefault();
			let active = $(this).closest('.ev_list').is('#ev_active');

			e.data.obj.update_event_attr($(this), active);
		});
		
		$('body').on('click', '#ev_update', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.update_event();
		});
		
		$('body').on('click', '.ev__style_options--close', {obj: this}, function(e){
			e.preventDefault();
			
			$('.ev__style_body--selector').hide();
		});
		
		$('body').on('click', '.ev__style_body--selected', {obj: this}, function(e){
			e.preventDefault();
			
			$('.ev__style_body--selector').show();
		});
		
		$('body').on('click', '.ev__style_option', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.update_icon_type($(this));
		});
		
		
	}
	
	
	open(){
		
		//set_event();
		$('#event_manager').css("display", "flex").hide().fadeIn(200);
		
	}
	
	
	close(){
		$('#event_manager').fadeOut(200);
	}
	
	
	set_event(ev) {
		
		let el = Trip.content.b[ev.block_id].e[ev.el_id];
		this.style = Trip.styles[el.c.style];
		
		//set the key values in the manager for this event
		$('.ev__style_icon').text(this.style.icon);
		$('.ev__style_name').text(this.style.name);
		$('#ev_settings_type_id').val(this.style.id);
		$('#ev_settings_el_id').val(ev.el_id);
		$('#ev_settings_block_id').val(ev.block_id);
		
			
		/*
		// We're currently assuming all fields are relevant. So, no need to build the selector system
		let $entry = $('<li/>', {
			'data-name': ''
		});
		$('.ev_list').html('');
		
		for (const [name, bool] of Object.entries(this.data)) {
			$entry.data('name', name);
			
			switch(name){
				case 'map':
					$entry.text('Map Marker');
					break;
				case 'date_time':
					$entry.text('Date &amp; Time');
					break;
				case 'description':
					$entry.text('Description');
					break;
				case 'expense':
					$entry.text('Expenses');
					break;
				case 'directions_link':
					$entry.text('Directions Link');
					break;
				case 'location_link':
					$entry.text('Location Link');
					break;
			}
			
			if(bool){
				$('#ev_active').append($entry);
			}else{
				$('#ev_inactive').append($entry);
			}
		}
		*/
	}
	
	update_event_attr($item, state){
		let $content = $item;
		let name = $item.data('name');
		$item.remove();
		
		if(state){
			
			$('#ev_inactive').append($content);
			this.data[name] = 0;
			
		}else{
			
			$('#ev_active').append($content);
			this.data[name] = 1;
			
		}
		
		
		
	}
	
	
	update_icon_type($icon){
		
		let type_id = $icon.attr('data-type_id');
		let type_icon = $icon.attr('data-type_icon');
		let type_category = $icon.attr('data-type_category');
		let type_name = $icon.attr('data-type_name');
		
		//update icon display for the manager
		$('.ev__style_icon').text(type_icon);
		$('.ev__style_name').text(type_name);
		$('#ev_settings_type_id').val(type_id);
		
		//hide the selector
		$('.ev__style_body--selector').hide();
		
	}
	
	
	update_event(){
		
		let block_id = $('#ev_settings_block_id').val();
		let el_id = $('#ev_settings_el_id').val();
		let type_id = $('#ev_settings_type_id').val();
		let $event = $(`.e[data-block_id="${block_id}"][data-el_id="${el_id}"]`);
		let s = Trip.styles[type_id];
		
		//if the image has changed, update the display and objects
		//if(s.id != this.style.id){
			//update the main element
			Trip.content.b[block_id].e[el_id].c.style = type_id;
			$event.find('.card__image span.material-symbols-outlined').text(s.icon);
			$event.find(`input[name="b[${block_id}][e][${el_id}][c][style]"]`).val(s.id);
			
			//and the markers
			for (const [m_id, m] of Object.entries(Trip.content.b[block_id].e[el_id].m)) {
				Trip.content.b[block_id].e[el_id].m[m_id].type = s.id;
				$event.find(`input[name="b[${block_id}][e][${el_id}][m][${m_id}][type]"]`).val(s.id);
				
				//update the map markers
				if(can_display(Trip.content.b[block_id].e[el_id].m[m_id].marker)){
					update_marker_display(Trip.content.b[block_id].e[el_id].m[m_id]);
				}
			}
			
		//}
		
		
		this.close();
	}
	
	
}